import Select from 'domains/core/components/Select';
import useCommunicationTypesList from 'hooks/queries/useCommunicationTypesList';
import { Box, Typography, Stack } from '@mui/material';
import { Warning } from '@mui/icons-material';

const communicationTypesLabelMap: Record<string, string> = {
    commercial: 'Commercial',
    transactional: 'Transactional',
};

type Props = {
    handleCommunicationTypeSelect: (event: any) => void;
    selectedCommunicationType: string;
    removeUnsubscribeLinkMessage?: string;
};

const CommunicationTypeOptionSelect = ({
    handleCommunicationTypeSelect,
    selectedCommunicationType,
    removeUnsubscribeLinkMessage,
}: Props) => {
    const { data } = useCommunicationTypesList();
    const communicationTypeOptions = data?.map((item) => ({
        label: communicationTypesLabelMap[item],
        value: item,
    }));

    return (
        <Stack spacing={1}>
            <Select
                data-testid="communication-type-select"
                error={false}
                fullWidth
                label="Communication Type"
                onChange={(e: any) => handleCommunicationTypeSelect(e)}
                type="string"
                value={selectedCommunicationType}
                values={communicationTypeOptions}
            />
            {removeUnsubscribeLinkMessage && (
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%', mt: 0.5 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <Warning sx={{ fontSize: '0.75rem', color: '#ed6c02' }} />
                        <Typography
                            data-testid="warning-text"
                            variant="body2"
                            sx={{
                                color: '#ed6c02',
                                fontSize: '0.75rem',
                            }}
                        >
                            {removeUnsubscribeLinkMessage}
                        </Typography>
                    </Box>
                </Box>
            )}
        </Stack>
    );
};

export default CommunicationTypeOptionSelect;
